import {lazy} from '@aboutyou/lazy-imports';

export const HeartBeat = lazy(
  () =>
    import('./HeartBeat.eager').then(mod => ({
      default: mod.HeartBeat,
    })),
  {skipSuspense: true},
);
